import React, { useState } from "react";
import { Link } from "react-router-dom";
import { CaretRight } from "@phosphor-icons/react";
import PageHeader from "../components/PageHeader";
import { PREMA_TABS } from "../data/prematuriteData";

export default function Prematurite() {
  const [active, setActive] = useState(PREMA_TABS[0].id);
  const tab = PREMA_TABS.find((t) => t.id === active);

  return (
    <div>
      <PageHeader title="Naissance prématurée" back />

      <div className="mb-4 px-6">
        <div className="overflow-hidden rounded-[24px] shadow-[0_6px_24px_rgba(54,48,43,0.08)]">
          <img
            src="/fiches/prematurite.jpg"
            alt="Espace Naissance prématurée"
            data-testid="prematurite-header-image"
            className="aspect-[16/9] w-full object-cover"
          />
        </div>
      </div>

      <div className="px-6">
        <div className="rounded-[26px] bg-[#9b8ec4]/12 p-5">
          <p className="font-display text-[18px] font-medium text-[#7E70AE]">Un cocon dans le cocon</p>
          <p className="mt-2 text-[14px] leading-relaxed text-[#36302B]/70">
            Sept espaces pour vous accompagner, de l'annonce au long cours. On valide d'abord, on informe
            ensuite. Chaque fiche cite ses sources.
          </p>
        </div>
      </div>

      {/* Tabs */}
      <div className="mt-4 flex gap-2 overflow-x-auto px-6 pb-1 hide-scrollbar">
        {PREMA_TABS.map((t) => (
          <button
            key={t.id}
            data-testid={`prema-tab-${t.id}`}
            onClick={() => setActive(t.id)}
            className="whitespace-nowrap rounded-full px-4 py-2 text-[13px] font-bold transition-colors"
            style={{
              backgroundColor: active === t.id ? "#7E70AE" : "#FFFFFF",
              color: active === t.id ? "#FFFFFF" : "rgba(54,48,43,0.6)",
              border: "1px solid rgba(54,48,43,0.08)",
            }}
          >
            {t.label}
          </button>
        ))}
      </div>

      <div className="mt-4 px-6">
        <p className="mb-3 text-[13.5px] italic text-[#36302B]/55">{tab.intro}</p>
        <div className="space-y-3">
          {tab.fiches.map((f) => (
            <Link
              key={f.id}
              to={`/prema/${f.id}`}
              data-testid={`prema-fiche-${f.id}`}
              className="flex items-center gap-3 rounded-3xl border border-[#36302B]/6 bg-white p-4 shadow-[0_4px_20px_rgba(54,48,43,0.03)] transition-transform hover:-translate-y-1"
            >
              <div className="h-14 w-14 shrink-0 overflow-hidden rounded-2xl bg-[#9b8ec4]/10">
                <img
                  src={`/prema/${f.id}.jpg`}
                  alt=""
                  loading="lazy"
                  className="h-full w-full object-cover"
                  onError={(e) => { e.currentTarget.style.display = "none"; }}
                />
              </div>
              <div className="flex-1">
                <p className="font-display text-[16px] font-medium leading-snug text-[#36302B]">{f.title}</p>
                <p className="mt-0.5 text-[13px] leading-snug text-[#36302B]/60">{f.excerpt}</p>
              </div>
              <CaretRight size={20} color="#7E70AE" weight="bold" className="opacity-50" />
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
